import {Injectable} from "@angular/core";
import {AuthService} from "../../+login/auth.service";
import {isNullOrUndefined} from "util";


/**
 * Created by gcuellar on 20/04/17.
 */
@Injectable()
export class HasPermissionService {
    /**
     *
     * @returns {[string,string]}
     *      string array with user permissions
     */
    constructor(private authService: AuthService) {
    }

    getPermissions() {
        return !isNullOrUndefined(this.authService.token) ? this.authService.token.roles : [];
    }

    /**
     *
     * @param Modules
     *      string with requested comma separated modules
     *      @format module_submodule
     * @returns {boolean}
     *      true if the user has permission of some requested modules
     */
    hasPermission(Modules: string) {
        if (!!Modules) {
            let ModulesArray = Modules.split(','); //Makes an array of modules

            return ModulesArray.some((Module) => {
                let searchPattern, hasPermission; //Variables to save the search pattern and a boolean if the permission was found
                let notPermissionFlag = (Module[0] === '!'); //Check if there is a not operator in the module (true/false)
                if (notPermissionFlag)
                    Module = Module.slice(1);
                Module = Module.trim().toUpperCase(); //Clear white spaces and makes string uppercase

                if (Module.search(/ROLE_.*/) === -1)
                    searchPattern = new RegExp('\\bROLE_' + Module + '\\b');
                else
                    searchPattern = new RegExp('\\b' + Module + '\\b');

                hasPermission = !!this.getPermissions().find((Permission) => {
                    return (Permission.search(searchPattern) !== -1);
                });
                return hasPermission !== notPermissionFlag;
            });
        }
    }

    /**
     *
     * @param permissionRequest
     *      string with requested comma separated modules
     *      @format module.submodule
     * @returns {boolean}
     *      true if the user has some requested permission
     */
    canAccess(permissionRequest: string) {
        if (!!permissionRequest) {
            permissionRequest = permissionRequest.trim().replace(/\./g, '_'); //Replace dots (.) by underscore (_)

            return this.hasPermission(permissionRequest);
        }
    }

    isLogged() {
        return !!this.authService.token;
    }
}